import React from 'react'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const IconSquareEdit = (props) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    {...props}
  >
    <path
      d="M5.74612 1.39453H3.87662C2.33912 1.39453 1.37512 2.48303 1.37512 4.02403V8.18103C1.37512 9.72203 2.33462 10.8105 3.87662 10.8105H8.28862C9.83112 10.8105 10.7906 9.72203 10.7906 8.18103V6.16703"
      stroke="#158463"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.41382 5.46049L8.15032 1.72399C8.61582 1.25899 9.37032 1.25899 9.83582 1.72399L10.4443 2.33249C10.9098 2.79799 10.9098 3.55299 10.4443 4.01799L6.68982 7.77249C6.48632 7.97599 6.21032 8.09049 5.92232 8.09049H4.04932L4.09632 6.20049C4.10332 5.92249 4.21682 5.65749 4.41382 5.46049Z"
      stroke="#158463"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.58252 2.30127L9.86552 4.58427"
      stroke="#158463"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SVG>
)

export default withIconStyles(IconSquareEdit)
